import {MemberShipConfig} from '@/store/Constraints';

const MemberShipStore = {
  namespaced: true,
  state: {
    memberShipList: {					
      id: '',				
      pw: '',				
      snsChannel: '',				
      snsId: '',				
      name: '',				
      gender: '',				
      mobile: '',				
      birth: '',				
      ci: '',				
      di: '',				
      termsAgree: 'N',				
      privateAgree: 'N',				
      positionAgree: 'N',				
      marketingSMSAgree: 'N',				
      marketingPushAgree: 'N',				
      marketingEmailAgree: 'N'				
    },
    agreeResult: '',
    checkEmail: '',
    checkNickname: '',
  },
  getters: {
    [MemberShipConfig.GET_LIST]: (state) => state.memberShipList,
  },
  mutations: {
    [MemberShipConfig.CHECK_EMAIL]: (state, payload) => {

    },
    [MemberShipConfig.CHECK_NICKNAME]: (state, payload) => {

    },
    [MemberShipConfig.AGREE_ALL]: (state, payload) => {
      Object.assign(state.memberShipList, payload.data)
    },
  },
  actions: {
    [MemberShipConfig.CHECK_EMAIL]: (store, payload) => {
      store.commit(MemberShipConfig.CHECK_EMAIL, {})
    },
    [MemberShipConfig.CHECK_NICKNAME]: (store, payload) => {
      store.commit(MemberShipConfig.CHECK_NICKNAME, {})
    },
    [MemberShipConfig.AGREE_ALL]: (store, payload) => {
      Object.assign(state.memberShipList, payload.data);
      store.commit(MemberShipConfig.AGREE_ALL, {})
    },
  }
}
export default MemberShipStore;


// WEBPACK FOOTER //
// ./src/store/member/MemberShipStore.js